export const getMaskForType = (type, currentValue) => {
  if (type === 'cpf') return '999.999.999-99';
  if (type === 'cnpj') return '**.***.***/****-99';
  if (type === 'cep') return '99999-999';
  if (type === 'telefone') {
    const rawValue = (currentValue || '').replace(/\D/g, '');
    return rawValue.length <= 10 ? '(99) 9999-99999' : '(99) 99999-9999';
  }
  return null;
};



// WEBPACK FOOTER //
// ./src/design-system/atoms/Input/utils/inputHelpers.js